// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ArtworkBatchGetMediaIdData, ArtworkBatchGetMediaIdResponses, ArtworkCreateFromMediaData, ArtworkCreateFromMediaErrors, ArtworkCreateFromMediaResponses, ArtworkGetDailyRankingArtworksData, ArtworkGetDailyRankingArtworksResponses, ArtworkGetFollowingNewsArtworksData, ArtworkGetFollowingNewsArtworksResponses, ArtworkGetNewestArtworksData, ArtworkGetNewestArtworksResponses, ArtworkGetRecommendArtworksData, ArtworkGetRecommendArtworksErrors, ArtworkGetRecommendArtworksResponses, ArtworkGetRecommendArtworksVisitorData, ArtworkGetRecommendArtworksVisitorResponses, ArtworkGetSimilarArtworksData, ArtworkGetSimilarArtworksResponses, ArtworkGetTrendingArtworksData, ArtworkGetTrendingArtworksResponses, AttributionCreateClickEventData, AttributionCreateClickEventResponses, AttributionUpsertIdentifiersData, AttributionUpsertIdentifiersErrors, AttributionUpsertIdentifiersResponses, AuthResetForgetPasswordData, AuthResetForgetPasswordResponses, AuthSendForgetPasswordCodeData, AuthSendForgetPasswordCodeResponses, AuthSignInWithEmailData, AuthSignInWithEmailResponses, AuthSignInWithGoogleTokenData, AuthSignInWithGoogleTokenResponses, BannerListData, BannerListResponses, CampaignAdsListData, CampaignAdsListResponses, ClaimClaimData, ClaimClaimErrors, ClaimClaimResponses, ClaimGetData, ClaimGetErrors, ClaimGetResponses, ClaimListData, ClaimListErrors, ClaimListResponses, ContentSafetyPreferenceGetContentSafetyPreferencesData, ContentSafetyPreferenceGetContentSafetyPreferencesErrors, ContentSafetyPreferenceGetContentSafetyPreferencesResponses, ContentSafetyPreferenceUpdateContentSafetyPreferenceData, ContentSafetyPreferenceUpdateContentSafetyPreferenceErrors, ContentSafetyPreferenceUpdateContentSafetyPreferenceResponses, ContestListData, ContestListResponses, ContestV2CreateCheckData, ContestV2CreateCheckResponses, ContestV2CreateData, ContestV2CreateErrors, ContestV2CreateResponses, ContestV2FollowData, ContestV2FollowErrors, ContestV2FollowResponses, ContestV2GetBySlugData, ContestV2GetBySlugErrors, ContestV2GetBySlugResponses, ContestV2ListArtworkByUserData, ContestV2ListArtworkByUserErrors, ContestV2ListArtworkByUserResponses, ContestV2ListArtworkData, ContestV2ListArtworkErrors, ContestV2ListArtworkResponses, ContestV2ListBannerData, ContestV2ListBannerResponses, ContestV2ListCreatedByUserData, ContestV2ListCreatedByUserResponses, ContestV2ListData, ContestV2ListFollowByUserData, ContestV2ListFollowByUserResponses, ContestV2ListResponses, ContestV2ListWinnersData, ContestV2ListWinnersErrors, ContestV2ListWinnersResponses, ContestV2SubmitArtworkData, ContestV2SubmitArtworkErrors, ContestV2SubmitArtworkResponses, ContestV2UnfollowData, ContestV2UnfollowErrors, ContestV2UnfollowResponses, CreditExchangeCreateTransactionData, CreditExchangeCreateTransactionErrors, CreditExchangeCreateTransactionResponses, CreditExchangeExternalTokenStatusData, CreditExchangeExternalTokenStatusErrors, CreditExchangeExternalTokenStatusResponses, CreditExchangeRedeemTokenData, CreditExchangeRedeemTokenErrors, CreditExchangeRedeemTokenResponses, CreditExchangeTokenSummaryData, CreditExchangeTokenSummaryErrors, CreditExchangeTokenSummaryResponses, DecorationBatchData, DecorationBatchResponses, DecorationGetDecorationData, DecorationGetDecorationErrors, DecorationGetDecorationResponses, EventPassListData, EventPassListResponses, EventPassPurchaseData, EventPassPurchaseErrors, EventPassPurchaseResponses, EventPassResetEventPassesData, EventPassResetEventPassesResponses, EventPassUserPassesData, EventPassUserPassesResponses, ExtraPackageBoostGetByCodeData, ExtraPackageBoostGetByCodeErrors, ExtraPackageBoostGetByCodeResponses, ExtraPackageBoostListMyBoostsData, ExtraPackageBoostListMyBoostsResponses, ExtraPackageConfirmAppleData, ExtraPackageConfirmAppleErrors, ExtraPackageConfirmAppleResponses, ExtraPackageConfirmGoogleData, ExtraPackageConfirmGoogleErrors, ExtraPackageConfirmGoogleResponses, ExtraPackageConfirmWebData, ExtraPackageConfirmWebErrors, ExtraPackageConfirmWebResponses, ExtraPackageGetData, ExtraPackageGetErrors, ExtraPackageGetResponses, ExtraPackageListData, ExtraPackageListGroupsData, ExtraPackageListGroupsResponses, ExtraPackageListResponses, ExtraPackagePurchaseData, ExtraPackagePurchaseErrors, ExtraPackagePurchaseResponses, FootprintListActionsData, FootprintListActionsErrors, FootprintListActionsResponses, FootprintListPreferencesData, FootprintListPreferencesErrors, FootprintListPreferencesResponses, GenerationModelGetFeaturesByModelVersionIdData, GenerationModelGetFeaturesByModelVersionIdErrors, GenerationModelGetFeaturesByModelVersionIdResponses, GenerationModelGetInferenceProfilesData, GenerationModelGetInferenceProfilesErrors, GenerationModelGetInferenceProfilesResponses, GenerationModelGetLatestArtworksByModelData, GenerationModelGetLatestArtworksByModelErrors, GenerationModelGetLatestArtworksByModelResponses, GenerationModelGetMostLikedArtworksByModelData, GenerationModelGetMostLikedArtworksByModelErrors, GenerationModelGetMostLikedArtworksByModelResponses, GenerationModelGetMyModelPermissionData, GenerationModelGetMyModelPermissionResponses, GenerationModelGetSizeConfigData, GenerationModelGetSizeConfigErrors, GenerationModelGetSizeConfigResponses, GenerationModelGetStyleKeysData, GenerationModelGetStyleKeysErrors, GenerationModelGetStyleKeysResponses, GenerationModelGetTrendingArtworksByModelData, GenerationModelGetTrendingArtworksByModelErrors, GenerationModelGetTrendingArtworksByModelResponses, GenerationModelImportExternalModelData, GenerationModelImportExternalModelErrors, GenerationModelImportExternalModelResponses, I18nGetTrackUsageData, I18nGetTrackUsageResponses, I18nPostTrackUsageData, I18nPostTrackUsageResponses, ImageCreateData, ImageCreateErrors, ImageCreateResponses, ImageFilterApplyFilterData, ImageFilterApplyFilterErrors, ImageFilterApplyFilterResponses, InternalImageCreateData, InternalImageCreateErrors, InternalImageCreateResponses, InternalReferralBindData, InternalReferralBindErrors, InternalReferralBindResponses, InternalTaskEditCreateData, InternalTaskEditCreateErrors, InternalTaskEditCreateResponses, InternalTaskGetByIdData, InternalTaskGetByIdErrors, InternalTaskGetByIdResponses, InternalTaskGetModerationData, InternalTaskGetModerationErrors, InternalTaskGetModerationResponses, InternalUserExternalProfilesBindData, InternalUserExternalProfilesBindErrors, InternalUserExternalProfilesBindResponses, InternalUserExternalProfilesListByUserIdData, InternalUserExternalProfilesListByUserIdErrors, InternalUserExternalProfilesListByUserIdResponses, KaisuukenCheckData, KaisuukenCheckErrors, KaisuukenCheckResponses, KaisuukenListData, KaisuukenListErrors, KaisuukenListResponses, KaisuukenLogsData, KaisuukenLogsErrors, KaisuukenLogsResponses, KaisuukenSearchData, KaisuukenSearchErrors, KaisuukenSearchResponses, KaisuukenSummaryData, KaisuukenSummaryErrors, KaisuukenSummaryResponses, KaisuukenTemplateListData, KaisuukenTemplateListResponses, KotoneCreditClaimMonthlyMembershipCreditPackData, KotoneCreditClaimMonthlyMembershipCreditPackErrors, KotoneCreditClaimMonthlyMembershipCreditPackResponses, KotoneCreditExchangeCreditPackData, KotoneCreditExchangeCreditPackErrors, KotoneCreditExchangeCreditPackResponses, KotoneCreditGetMonthlyMembershipGrantStatusData, KotoneCreditGetMonthlyMembershipGrantStatusResponses, KotoneOrderCancelData, KotoneOrderCancelErrors, KotoneOrderCancelResponses, KotoneOrderCompleteData, KotoneOrderCompleteErrors, KotoneOrderCompleteResponses, KotoneOrderConfirmRefundData, KotoneOrderConfirmRefundErrors, KotoneOrderConfirmRefundResponses, KotoneOrderCreateData, KotoneOrderCreateErrors, KotoneOrderCreateResponses, KotoneOrderGetData, KotoneOrderGetErrors, KotoneOrderGetResponses, LotteryClaimRewardData, LotteryClaimRewardResponses, LotteryPurchaseTokenData, LotteryPurchaseTokenResponses, LotteryResetData, LotteryResetResponses, LotteryRollData, LotteryRollResponses, MediaGetAudioUploadUrlData, MediaGetAudioUploadUrlErrors, MediaGetAudioUploadUrlResponses, MediaGetAudioUrlData, MediaGetAudioUrlErrors, MediaGetAudioUrlResponses, MediaGetMediaInfoData, MediaGetMediaInfoErrors, MediaGetMediaInfoResponses, MediaGetVideoThumbnailIdData, MediaGetVideoThumbnailIdErrors, MediaGetVideoThumbnailIdResponses, MediaRegisterAudioData, MediaRegisterAudioErrors, MediaRegisterAudioResponses, ModelExperimentSessionGetExpSessionData, ModelExperimentSessionGetExpSessionErrors, ModelExperimentSessionGetExpSessionResponses, ModelExperimentSessionSubmitPreferenceData, ModelExperimentSessionSubmitPreferenceErrors, ModelExperimentSessionSubmitPreferenceResponses, NotificationPreferenceGetNotificationPreferenceData, NotificationPreferenceGetNotificationPreferenceErrors, NotificationPreferenceGetNotificationPreferenceResponses, NotificationPreferenceSetNotificationPreferenceData, NotificationPreferenceSetNotificationPreferenceErrors, NotificationPreferenceSetNotificationPreferenceResponses, Oauth2AuthorizeData, Oauth2AuthorizeErrors, Oauth2AuthorizeResponses, Oauth2ClientAppleCallbackData, Oauth2ClientCallbackData, Oauth2ClientExchangeData, Oauth2ClientExchangeResponses, Oauth2ClientNativeData, Oauth2ClientNativeResponses, Oauth2ClientStartData, Oauth2ConsentData, Oauth2ConsentErrors, Oauth2ConsentResponses, Oauth2DeviceAuthorizationData, Oauth2DeviceAuthorizationErrors, Oauth2DeviceAuthorizationResponses, Oauth2DeviceConsentData, Oauth2DeviceConsentErrors, Oauth2DeviceConsentResponses, Oauth2DeviceVerifyData, Oauth2DeviceVerifyErrors, Oauth2DeviceVerifyResponses, Oauth2IntrospectData, Oauth2IntrospectErrors, Oauth2IntrospectResponses, Oauth2RevokeData, Oauth2RevokeErrors, Oauth2RevokeResponses, Oauth2ServerMetadataData, Oauth2ServerMetadataResponses, Oauth2TokenData, Oauth2TokenErrors, Oauth2TokenResponses, OrderGetByIdData, OrderGetByIdErrors, OrderGetByIdResponses, PaymentGetPaymentMethodsData, PaymentGetPaymentMethodsErrors, PaymentGetPaymentMethodsResponses, QuestV2ClaimRewardData, QuestV2ClaimRewardErrors, QuestV2ClaimRewardResponses, QuestV2ListCategoriesData, QuestV2ListCategoriesResponses, QuestV2ListEventQuestsData, QuestV2ListEventQuestsResponses, QuestV2ListFollowedPlatformsData, QuestV2ListFollowedPlatformsResponses, QuestV2ListQuestsData, QuestV2ListQuestsResponses, QuestV2ReportSocialFollowData, QuestV2ReportSocialFollowResponses, QuestV2ReportUrlVisitData, QuestV2ReportUrlVisitResponses, ReferenceVideoCreateData, ReferenceVideoCreateErrors, ReferenceVideoCreateResponses, ReferralCampaignEntriesData, ReferralCampaignEntriesErrors, ReferralCampaignEntriesResponses, ReferralCampaignInviteeStatusData, ReferralCampaignInviteeStatusErrors, ReferralCampaignInviteeStatusResponses, ReferralCampaignSummaryData, ReferralCampaignSummaryErrors, ReferralCampaignSummaryResponses, SpringPromotionEvent2026ChapterCompletionsData, SpringPromotionEvent2026ChapterCompletionsResponses, SpringPromotionEvent2026ClaimFreePullsData, SpringPromotionEvent2026ClaimFreePullsResponses, SpringPromotionEvent2026CompleteChapterData, SpringPromotionEvent2026CompleteChapterResponses, SpringPromotionEvent2026DailyCheckInData, SpringPromotionEvent2026DailyCheckInResponses, SpringPromotionEvent2026GrantTokensData, SpringPromotionEvent2026GrantTokensResponses, SpringPromotionEvent2026StatusData, SpringPromotionEvent2026StatusResponses, SsrClearExperimentCacheData, SsrClearExperimentCacheErrors, SsrClearExperimentCacheResponses, StyleKeyRefCreateData, StyleKeyRefCreateErrors, StyleKeyRefCreateResponses, SurprisePackListData, SurprisePackListResponses, SurprisePackPurchaseData, SurprisePackPurchaseErrors, SurprisePackPurchaseResponses, SurprisePackResetData, SurprisePackResetResponses, SurprisePackUserPacksData, SurprisePackUserPacksResponses, TackAutocompleteData, TackAutocompleteResponses, TackBatchData, TackBatchResponses, TackCuratedArtworksData, TackCuratedArtworksErrors, TackCuratedArtworksResponses, TackGalleryData, TackGalleryResponses, TackSyncFromPixaiTackData, TackSyncFromPixaiTackErrors, TackSyncFromPixaiTackResponses, TackTrendingData, TackTrendingResponses, TagSuggestPromptForImageData, TagSuggestPromptForImageErrors, TagSuggestPromptForImageResponses, TaskAcquirePreGeneratedData, TaskAcquirePreGeneratedErrors, TaskAcquirePreGeneratedResponses, TaskCancelRunningTaskData, TaskCancelRunningTaskErrors, TaskCancelRunningTaskResponses, TaskGetByIdData, TaskGetByIdErrors, TaskGetByIdResponses, TaskPredictWaitTimeData, TaskPredictWaitTimeErrors, TaskPredictWaitTimeResponses, TestOpsCreateTestUserData, TestOpsCreateTestUserErrors, TestOpsCreateTestUserResponses, TierRewardClaimAllAvailableData, TierRewardClaimAllAvailableErrors, TierRewardClaimAllAvailableResponses, TierRewardClaimData, TierRewardClaimErrors, TierRewardClaimResponses, TierRewardGetRewardTiersData, TierRewardGetRewardTiersErrors, TierRewardGetRewardTiersResponses, TierRewardResetData, TierRewardResetErrors, TierRewardResetResponses, UaNewbiePackGetSnapshotData, UaNewbiePackGetSnapshotErrors, UaNewbiePackGetSnapshotResponses, UaNewbiePackMarkAhaShownData, UaNewbiePackMarkAhaShownErrors, UaNewbiePackMarkAhaShownResponses, UserCreateMyAccessTokenData, UserCreateMyAccessTokenErrors, UserCreateMyAccessTokenResponses, UserCreateMyWebhookData, UserCreateMyWebhookErrors, UserCreateMyWebhookResponses, UserDecorationRelationGetUserDecorationRelationData, UserDecorationRelationGetUserDecorationRelationErrors, UserDecorationRelationGetUserDecorationRelationResponses, UserDecorationRelationUpdateUserDecorationRelationData, UserDecorationRelationUpdateUserDecorationRelationErrors, UserDecorationRelationUpdateUserDecorationRelationResponses, UserDeleteMyWebhookData, UserDeleteMyWebhookErrors, UserDeleteMyWebhookResponses, UserGetMeData, UserGetMeResponses, UserGetMyActivatedOtpData, UserGetMyActivatedOtpErrors, UserGetMyActivatedOtpResponses, UserGetMyDecorationsData, UserGetMyDecorationsErrors, UserGetMyDecorationsResponses, UserGetMyMembershipData, UserGetMyMembershipErrors, UserGetMyMembershipResponses, UserGetMyQuotaData, UserGetMyQuotaErrors, UserGetMyQuotaResponses, UserGetUserActiveDecorationsData, UserGetUserActiveDecorationsErrors, UserGetUserActiveDecorationsResponses, UserGetUserArtworksLatestData, UserGetUserArtworksLatestResponses, UserGetUserArtworksMostLikedData, UserGetUserArtworksMostLikedResponses, UserGetUserArtworksOldestData, UserGetUserArtworksOldestResponses, UserGetUserByIdData, UserGetUserByIdErrors, UserGetUserByIdResponses, UserGetUserByUsernameData, UserGetUserByUsernameErrors, UserGetUserByUsernameResponses, UserListMyAccessTokensData, UserListMyAccessTokensErrors, UserListMyAccessTokensResponses, UserListMyWebhooksData, UserListMyWebhooksErrors, UserListMyWebhooksResponses, UserOrderEmailListData, UserOrderEmailListErrors, UserOrderEmailListResponses, UserRevokeMyAccessTokenData, UserRevokeMyAccessTokenErrors, UserRevokeMyAccessTokenResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List quest categories
 */
export const questV2ListCategories = <ThrowOnError extends boolean = false>(options?: Options<QuestV2ListCategoriesData, ThrowOnError>) => (options?.client ?? client).get<QuestV2ListCategoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/categories',
    ...options
});

/**
 * List quests for the current user
 */
export const questV2ListQuests = <ThrowOnError extends boolean = false>(options?: Options<QuestV2ListQuestsData, ThrowOnError>) => (options?.client ?? client).get<QuestV2ListQuestsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/quests',
    ...options
});

/**
 * List event quests for the current user
 */
export const questV2ListEventQuests = <ThrowOnError extends boolean = false>(options?: Options<QuestV2ListEventQuestsData, ThrowOnError>) => (options?.client ?? client).get<QuestV2ListEventQuestsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/event-quests',
    ...options
});

/**
 * Claim reward for a completed quest
 */
export const questV2ClaimReward = <ThrowOnError extends boolean = false>(options: Options<QuestV2ClaimRewardData, ThrowOnError>) => (options.client ?? client).post<QuestV2ClaimRewardResponses, QuestV2ClaimRewardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/quests/{questId}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report that the user visited a quest URL, advancing progress
 */
export const questV2ReportUrlVisit = <ThrowOnError extends boolean = false>(options: Options<QuestV2ReportUrlVisitData, ThrowOnError>) => (options.client ?? client).post<QuestV2ReportUrlVisitResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/report-visit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report that the user followed a social platform, advancing progress
 */
export const questV2ReportSocialFollow = <ThrowOnError extends boolean = false>(options: Options<QuestV2ReportSocialFollowData, ThrowOnError>) => (options.client ?? client).post<QuestV2ReportSocialFollowResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/report-social-follow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List platforms the current user has followed
 */
export const questV2ListFollowedPlatforms = <ThrowOnError extends boolean = false>(options?: Options<QuestV2ListFollowedPlatformsData, ThrowOnError>) => (options?.client ?? client).get<QuestV2ListFollowedPlatformsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/quest-v2/followed-platforms',
    ...options
});

/**
 * Get Spring Promotion 2026 lottery status for current user
 */
export const springPromotionEvent2026Status = <ThrowOnError extends boolean = false>(options?: Options<SpringPromotionEvent2026StatusData, ThrowOnError>) => (options?.client ?? client).get<SpringPromotionEvent2026StatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/status',
    ...options
});

/**
 * Claim daily free pulls for Spring Promotion 2026
 */
export const springPromotionEvent2026ClaimFreePulls = <ThrowOnError extends boolean = false>(options?: Options<SpringPromotionEvent2026ClaimFreePullsData, ThrowOnError>) => (options?.client ?? client).post<SpringPromotionEvent2026ClaimFreePullsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/claim-free-pulls',
    ...options
});

/**
 * Mark a drama chapter as completed and grant rewards
 */
export const springPromotionEvent2026CompleteChapter = <ThrowOnError extends boolean = false>(options: Options<SpringPromotionEvent2026CompleteChapterData, ThrowOnError>) => (options.client ?? client).post<SpringPromotionEvent2026CompleteChapterResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/complete-chapter',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List drama chapters the current user has completed
 */
export const springPromotionEvent2026ChapterCompletions = <ThrowOnError extends boolean = false>(options?: Options<SpringPromotionEvent2026ChapterCompletionsData, ThrowOnError>) => (options?.client ?? client).get<SpringPromotionEvent2026ChapterCompletionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/chapter-completions',
    ...options
});

/**
 * Trigger daily check-in quest for Spring Promotion 2026
 */
export const springPromotionEvent2026DailyCheckIn = <ThrowOnError extends boolean = false>(options?: Options<SpringPromotionEvent2026DailyCheckInData, ThrowOnError>) => (options?.client ?? client).post<SpringPromotionEvent2026DailyCheckInResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/daily-check-in',
    ...options
});

/**
 * Grant event tokens to the caller (admin/debug)
 */
export const springPromotionEvent2026GrantTokens = <ThrowOnError extends boolean = false>(options: Options<SpringPromotionEvent2026GrantTokensData, ThrowOnError>) => (options.client ?? client).post<SpringPromotionEvent2026GrantTokensResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/spring-promotion-2026/grant-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available event passes
 */
export const eventPassList = <ThrowOnError extends boolean = false>(options: Options<EventPassListData, ThrowOnError>) => (options.client ?? client).get<EventPassListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/pass',
    ...options
});

/**
 * Get current user pass records
 */
export const eventPassUserPasses = <ThrowOnError extends boolean = false>(options: Options<EventPassUserPassesData, ThrowOnError>) => (options.client ?? client).get<EventPassUserPassesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/pass/user-passes',
    ...options
});

/**
 * Purchase a pass
 */
export const eventPassPurchase = <ThrowOnError extends boolean = false>(options: Options<EventPassPurchaseData, ThrowOnError>) => (options.client ?? client).post<EventPassPurchaseResponses, EventPassPurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/pass/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete all user event passes for a given event (admin only)
 */
export const eventPassResetEventPasses = <ThrowOnError extends boolean = false>(options: Options<EventPassResetEventPassesData, ThrowOnError>) => (options.client ?? client).post<EventPassResetEventPassesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/pass/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List available surprise pack SKUs
 */
export const surprisePackList = <ThrowOnError extends boolean = false>(options: Options<SurprisePackListData, ThrowOnError>) => (options.client ?? client).get<SurprisePackListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/surprise-pack',
    ...options
});

/**
 * Get current user surprise pack records
 */
export const surprisePackUserPacks = <ThrowOnError extends boolean = false>(options: Options<SurprisePackUserPacksData, ThrowOnError>) => (options.client ?? client).get<SurprisePackUserPacksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/surprise-pack/user-packs',
    ...options
});

/**
 * Purchase a surprise pack
 */
export const surprisePackPurchase = <ThrowOnError extends boolean = false>(options: Options<SurprisePackPurchaseData, ThrowOnError>) => (options.client ?? client).post<SurprisePackPurchaseResponses, SurprisePackPurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/surprise-pack/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete all user surprise packs for a given event (admin only)
 */
export const surprisePackReset = <ThrowOnError extends boolean = false>(options: Options<SurprisePackResetData, ThrowOnError>) => (options.client ?? client).post<SurprisePackResetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/surprise-pack/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a new artwork from uploaded media
 *
 * Creates a new artwork from user-uploaded media. Requires authentication and Turnstile verification for web clients.
 */
export const artworkCreateFromMedia = <ThrowOnError extends boolean = false>(options: Options<ArtworkCreateFromMediaData, ThrowOnError>) => (options.client ?? client).post<ArtworkCreateFromMediaResponses, ArtworkCreateFromMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/from-media',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch get media IDs for artworks
 */
export const artworkBatchGetMediaId = <ThrowOnError extends boolean = false>(options: Options<ArtworkBatchGetMediaIdData, ThrowOnError>) => (options.client ?? client).post<ArtworkBatchGetMediaIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/batch-media-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get similar artworks
 *
 * Returns artworks similar to the given artwork, using vector similarity search on image embeddings.
 */
export const artworkGetSimilarArtworks = <ThrowOnError extends boolean = false>(options: Options<ArtworkGetSimilarArtworksData, ThrowOnError>) => (options.client ?? client).get<ArtworkGetSimilarArtworksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/{artworkId}/similar',
    ...options
});

/**
 * Get personalized recommended artworks feed
 *
 * Returns personalized recommended artworks for the authenticated user.
 */
export const artworkGetRecommendArtworks = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetRecommendArtworksData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetRecommendArtworksResponses, ArtworkGetRecommendArtworksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/recommend',
    ...options
});

/**
 * Get recommended artworks feed for visitors
 *
 * Returns recommended artworks for unauthenticated visitors.
 */
export const artworkGetRecommendArtworksVisitor = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetRecommendArtworksVisitorData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetRecommendArtworksVisitorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/recommend-visitor',
    ...options
});

/**
 * Get trending artworks feed
 *
 * Returns the weekly trending artworks feed ranked by a velocity-weighted like score.
 */
export const artworkGetTrendingArtworks = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetTrendingArtworksData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetTrendingArtworksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/feed/trending',
    ...options
});

/**
 * Get daily-ranking artworks feed
 *
 * Returns the deduplicated daily ranking feed (one artwork per author, ranked by likedCount).
 */
export const artworkGetDailyRankingArtworks = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetDailyRankingArtworksData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetDailyRankingArtworksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/daily-ranking',
    ...options
});

/**
 * Get following-news artworks feed
 *
 * Returns the latest public artwork from authors the current user follows, sorted by createdAt desc. Returns an empty page for unauthenticated requests.
 */
export const artworkGetFollowingNewsArtworks = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetFollowingNewsArtworksData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetFollowingNewsArtworksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/feed/following-news',
    ...options
});

/**
 * Get newest artworks feed
 *
 * Returns public artworks sorted by createdAt desc. Visitor-cacheable for anonymous callers; logged-in responses skip the edge cache.
 */
export const artworkGetNewestArtworks = <ThrowOnError extends boolean = false>(options?: Options<ArtworkGetNewestArtworksData, ThrowOnError>) => (options?.client ?? client).get<ArtworkGetNewestArtworksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/artwork/feed/newest',
    ...options
});

/**
 * Upsert device/browser identifiers
 *
 * Upserts device and browser identifiers for the current session. Requires authentication.
 */
export const attributionUpsertIdentifiers = <ThrowOnError extends boolean = false>(options: Options<AttributionUpsertIdentifiersData, ThrowOnError>) => (options.client ?? client).post<AttributionUpsertIdentifiersResponses, AttributionUpsertIdentifiersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/attribution/identifiers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record an ad click event
 *
 * Records an ad click event for attribution tracking. No authentication required.
 */
export const attributionCreateClickEvent = <ThrowOnError extends boolean = false>(options: Options<AttributionCreateClickEventData, ThrowOnError>) => (options.client ?? client).post<AttributionCreateClickEventResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/attribution/click-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a verification code to the given email so the user can reset their password
 */
export const authSendForgetPasswordCode = <ThrowOnError extends boolean = false>(options: Options<AuthSendForgetPasswordCodeData, ThrowOnError>) => (options.client ?? client).post<AuthSendForgetPasswordCodeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/forget-password/send-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset the password for the given email using the verification code
 */
export const authResetForgetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthResetForgetPasswordData, ThrowOnError>) => (options.client ?? client).post<AuthResetForgetPasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/forget-password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password. Creates a new account when no user is registered under the submitted email.
 */
export const authSignInWithEmail = <ThrowOnError extends boolean = false>(options: Options<AuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<AuthSignInWithEmailResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/sign-in/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with a Google identity token. Creates an account if none is linked.
 */
export const authSignInWithGoogleToken = <ThrowOnError extends boolean = false>(options: Options<AuthSignInWithGoogleTokenData, ThrowOnError>) => (options.client ?? client).post<AuthSignInWithGoogleTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/sign-in/token/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userGetMe = <ThrowOnError extends boolean = false>(options?: Options<UserGetMeData, ThrowOnError>) => (options?.client ?? client).get<UserGetMeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me',
    ...options
});

export const userGetUserById = <ThrowOnError extends boolean = false>(options: Options<UserGetUserByIdData, ThrowOnError>) => (options.client ?? client).get<UserGetUserByIdResponses, UserGetUserByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/by-id/{id}',
    ...options
});

export const userGetUserByUsername = <ThrowOnError extends boolean = false>(options: Options<UserGetUserByUsernameData, ThrowOnError>) => (options.client ?? client).get<UserGetUserByUsernameResponses, UserGetUserByUsernameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/by-name/{username}',
    ...options
});

/**
 * Get membership info for current user
 */
export const userGetMyMembership = <ThrowOnError extends boolean = false>(options?: Options<UserGetMyMembershipData, ThrowOnError>) => (options?.client ?? client).get<UserGetMyMembershipResponses, UserGetMyMembershipErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/membership',
    ...options
});

/**
 * Get active decorations for current user
 */
export const userGetMyDecorations = <ThrowOnError extends boolean = false>(options?: Options<UserGetMyDecorationsData, ThrowOnError>) => (options?.client ?? client).get<UserGetMyDecorationsResponses, UserGetMyDecorationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/decorations',
    ...options
});

/**
 * Get active decorations for a user
 */
export const userGetUserActiveDecorations = <ThrowOnError extends boolean = false>(options: Options<UserGetUserActiveDecorationsData, ThrowOnError>) => (options.client ?? client).get<UserGetUserActiveDecorationsResponses, UserGetUserActiveDecorationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/{id}/decorations',
    ...options
});

/**
 * Get activated OTP info for current user
 */
export const userGetMyActivatedOtp = <ThrowOnError extends boolean = false>(options?: Options<UserGetMyActivatedOtpData, ThrowOnError>) => (options?.client ?? client).get<UserGetMyActivatedOtpResponses, UserGetMyActivatedOtpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/otp',
    ...options
});

/**
 * List a user’s artworks, newest first
 *
 * Returns the given user’s artworks ordered by `createdAt` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward in the orderBy sequence → older items), **previous page** = `last` + `before` (walks backward → newer items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksLatest = <ThrowOnError extends boolean = false>(options: Options<UserGetUserArtworksLatestData, ThrowOnError>) => (options.client ?? client).get<UserGetUserArtworksLatestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/{userId}/artworks/latest',
    ...options
});

/**
 * List a user’s artworks, oldest first
 *
 * Returns the given user’s artworks ordered by `createdAt` ascending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → newer items), **previous page** = `last` + `before` (walks backward → older items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksOldest = <ThrowOnError extends boolean = false>(options: Options<UserGetUserArtworksOldestData, ThrowOnError>) => (options.client ?? client).get<UserGetUserArtworksOldestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/{userId}/artworks/oldest',
    ...options
});

/**
 * List a user’s artworks, most-liked first
 *
 * Returns the given user’s artworks ordered by `likedCount` descending. Standard relay cursor pagination: **next page** = `first` + `after` (walks forward → less-liked items), **previous page** = `last` + `before` (walks backward → more-liked items). Visibility (private/unlisted) is filtered out for non-owner viewers; sensitivity gating mirrors the GraphQL `artworks` resolver.
 */
export const userGetUserArtworksMostLiked = <ThrowOnError extends boolean = false>(options: Options<UserGetUserArtworksMostLikedData, ThrowOnError>) => (options.client ?? client).get<UserGetUserArtworksMostLikedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/{userId}/artworks/most-liked',
    ...options
});

/**
 * Get quota balance for current user
 */
export const userGetMyQuota = <ThrowOnError extends boolean = false>(options?: Options<UserGetMyQuotaData, ThrowOnError>) => (options?.client ?? client).get<UserGetMyQuotaResponses, UserGetMyQuotaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/quota',
    ...options
});

/**
 * List active access tokens for current user
 */
export const userListMyAccessTokens = <ThrowOnError extends boolean = false>(options?: Options<UserListMyAccessTokensData, ThrowOnError>) => (options?.client ?? client).get<UserListMyAccessTokensResponses, UserListMyAccessTokensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/access-token',
    ...options
});

/**
 * Create a new access token for current user
 */
export const userCreateMyAccessToken = <ThrowOnError extends boolean = false>(options: Options<UserCreateMyAccessTokenData, ThrowOnError>) => (options.client ?? client).post<UserCreateMyAccessTokenResponses, UserCreateMyAccessTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/access-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an access token
 */
export const userRevokeMyAccessToken = <ThrowOnError extends boolean = false>(options: Options<UserRevokeMyAccessTokenData, ThrowOnError>) => (options.client ?? client).delete<UserRevokeMyAccessTokenResponses, UserRevokeMyAccessTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/access-token/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List webhooks for current user
 */
export const userListMyWebhooks = <ThrowOnError extends boolean = false>(options?: Options<UserListMyWebhooksData, ThrowOnError>) => (options?.client ?? client).get<UserListMyWebhooksResponses, UserListMyWebhooksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/webhook',
    ...options
});

/**
 * Create a webhook for current user
 */
export const userCreateMyWebhook = <ThrowOnError extends boolean = false>(options: Options<UserCreateMyWebhookData, ThrowOnError>) => (options.client ?? client).post<UserCreateMyWebhookResponses, UserCreateMyWebhookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a webhook
 */
export const userDeleteMyWebhook = <ThrowOnError extends boolean = false>(options: Options<UserDeleteMyWebhookData, ThrowOnError>) => (options.client ?? client).delete<UserDeleteMyWebhookResponses, UserDeleteMyWebhookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/webhook/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const tagSuggestPromptForImage = <ThrowOnError extends boolean = false>(options: Options<TagSuggestPromptForImageData, ThrowOnError>) => (options.client ?? client).get<TagSuggestPromptForImageResponses, TagSuggestPromptForImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tag/suggest-prompt/{mediaId}',
    ...options
});

/**
 * Get a task by ID
 *
 * Returns the status and basic outputs of a task owned by the current user. Heavy fields (parameters, ...) are opt-in via with_<field>=true query params.
 */
export const taskGetById = <ThrowOnError extends boolean = false>(options: Options<TaskGetByIdData, ThrowOnError>) => (options.client ?? client).get<TaskGetByIdResponses, TaskGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/{id}',
    ...options
});

/**
 * Cancel a long-running task
 *
 * Cancels and refunds a task owned by the current user that has been running for at least 24 hours.
 */
export const taskCancelRunningTask = <ThrowOnError extends boolean = false>(options: Options<TaskCancelRunningTaskData, ThrowOnError>) => (options.client ?? client).post<TaskCancelRunningTaskResponses, TaskCancelRunningTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Predict task wait time
 *
 * Returns an estimated wait time for a generation task of the given priority and target model. Provide either a generationModelId (latest version is resolved) or a modelVersionId (used directly, matching the enqueue generation task flow).
 */
export const taskPredictWaitTime = <ThrowOnError extends boolean = false>(options: Options<TaskPredictWaitTimeData, ThrowOnError>) => (options.client ?? client).get<TaskPredictWaitTimeResponses, TaskPredictWaitTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/wait-time',
    ...options
});

/**
 * Acquire a pre-generated task
 *
 * Claims a pre-generated task for the current user. Tackled by tackId on the new path; falls back to the legacy TAG pool while migration is in flight.
 */
export const taskAcquirePreGenerated = <ThrowOnError extends boolean = false>(options: Options<TaskAcquirePreGeneratedData, ThrowOnError>) => (options.client ?? client).post<TaskAcquirePreGeneratedResponses, TaskAcquirePreGeneratedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/pre-generation/acquire',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the A/B model experiment session for a task
 *
 * Returns the experiment session attached to a multi-job root task, with images arranged per the session's display order. Returns 404 when the task has no associated session.
 */
export const modelExperimentSessionGetExpSession = <ThrowOnError extends boolean = false>(options: Options<ModelExperimentSessionGetExpSessionData, ThrowOnError>) => (options.client ?? client).get<ModelExperimentSessionGetExpSessionResponses, ModelExperimentSessionGetExpSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/{taskId}/model-experiment-session',
    ...options
});

/**
 * Submit the user preference for an A/B experiment session
 *
 * Records the user choice and resolves the session.
 */
export const modelExperimentSessionSubmitPreference = <ThrowOnError extends boolean = false>(options: Options<ModelExperimentSessionSubmitPreferenceData, ThrowOnError>) => (options.client ?? client).post<ModelExperimentSessionSubmitPreferenceResponses, ModelExperimentSessionSubmitPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/task/{taskId}/model-experiment-session/preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const testOpsCreateTestUser = <ThrowOnError extends boolean = false>(options: Options<TestOpsCreateTestUserData, ThrowOnError>) => (options.client ?? client).post<TestOpsCreateTestUserResponses, TestOpsCreateTestUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/test-ops/create-test-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get curated artwork feed for a tack
 */
export const tackCuratedArtworks = <ThrowOnError extends boolean = false>(options: Options<TackCuratedArtworksData, ThrowOnError>) => (options.client ?? client).get<TackCuratedArtworksResponses, TackCuratedArtworksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/{slug}/curated-artworks',
    ...options
});

/**
 * List trending IP/character tacks for gallery display
 *
 * Returns tacks in the `ip` and `character` categories that currently appear in the trending set, ordered by trending score descending (ties broken by tackId descending).
 */
export const tackGallery = <ThrowOnError extends boolean = false>(options?: Options<TackGalleryData, ThrowOnError>) => (options?.client ?? client).get<TackGalleryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/gallery',
    ...options
});

/**
 * List trending tacks
 *
 * Returns trending tacks with page-based pagination. Use the `sort` param to control ordering: `trending` (default) sorts by weighted score, `weekly` by 7-day artwork count, `daily` by 24-hour artwork count.
 */
export const tackTrending = <ThrowOnError extends boolean = false>(options?: Options<TackTrendingData, ThrowOnError>) => (options?.client ?? client).get<TackTrendingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/trending',
    ...options
});

/**
 * Sync tack data from pixai-tack service
 *
 * Receives tack updates from pixai-tack, invalidates cache and updates Elasticsearch
 */
export const tackSyncFromPixaiTack = <ThrowOnError extends boolean = false>(options: Options<TackSyncFromPixaiTackData, ThrowOnError>) => (options.client ?? client).post<TackSyncFromPixaiTackResponses, TackSyncFromPixaiTackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Autocomplete tack search with CJK support
 *
 * Prefix + fuzzy search over TackTermUnion. Kana input is converted to romaji for CJK coverage.
 */
export const tackAutocomplete = <ThrowOnError extends boolean = false>(options: Options<TackAutocompleteData, ThrowOnError>) => (options.client ?? client).get<TackAutocompleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/autocomplete',
    ...options
});

/**
 * Batch get tacks by IDs
 *
 * Returns tacks matching the given IDs, ordered to match the input `ids`. Each tack includes a small (avatar-sized) `thumbnailUrl` resolved server-side and a resolved `displayName` (user-language term → English term → `defaultName`; falls through to `defaultName` when `lang` is omitted). Unknown IDs are silently omitted. Capped at 100 IDs per request.
 */
export const tackBatch = <ThrowOnError extends boolean = false>(options: Options<TackBatchData, ThrowOnError>) => (options.client ?? client).get<TackBatchResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/tack/batch',
    ...options
});

export const extraPackageBoostListMyBoosts = <ThrowOnError extends boolean = false>(options?: Options<ExtraPackageBoostListMyBoostsData, ThrowOnError>) => (options?.client ?? client).get<ExtraPackageBoostListMyBoostsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/extra-package-boosts',
    ...options
});

export const extraPackageBoostGetByCode = <ThrowOnError extends boolean = false>(options: Options<ExtraPackageBoostGetByCodeData, ThrowOnError>) => (options.client ?? client).get<ExtraPackageBoostGetByCodeResponses, ExtraPackageBoostGetByCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/extra-package-boosts/{code}',
    ...options
});

/**
 * List purchasable extra-package SKUs for the caller
 */
export const extraPackageList = <ThrowOnError extends boolean = false>(options?: Options<ExtraPackageListData, ThrowOnError>) => (options?.client ?? client).get<ExtraPackageListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package',
    ...options
});

/**
 * Get a single extra-package SKU
 */
export const extraPackageGet = <ThrowOnError extends boolean = false>(options: Options<ExtraPackageGetData, ThrowOnError>) => (options.client ?? client).get<ExtraPackageGetResponses, ExtraPackageGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/{skuId}',
    ...options
});

/**
 * Create an order + dispatch payment for an extra-package SKU
 */
export const extraPackagePurchase = <ThrowOnError extends boolean = false>(options: Options<ExtraPackagePurchaseData, ThrowOnError>) => (options.client ?? client).post<ExtraPackagePurchaseResponses, ExtraPackagePurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm extra-package payment for web providers
 */
export const extraPackageConfirmWeb = <ThrowOnError extends boolean = false>(options: Options<ExtraPackageConfirmWebData, ThrowOnError>) => (options.client ?? client).post<ExtraPackageConfirmWebResponses, ExtraPackageConfirmWebErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/confirm/web',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm extra-package payment for Apple IAP
 */
export const extraPackageConfirmApple = <ThrowOnError extends boolean = false>(options: Options<ExtraPackageConfirmAppleData, ThrowOnError>) => (options.client ?? client).post<ExtraPackageConfirmAppleResponses, ExtraPackageConfirmAppleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/confirm/apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm extra-package payment for Google IAP
 */
export const extraPackageConfirmGoogle = <ThrowOnError extends boolean = false>(options: Options<ExtraPackageConfirmGoogleData, ThrowOnError>) => (options.client ?? client).post<ExtraPackageConfirmGoogleResponses, ExtraPackageConfirmGoogleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/confirm/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List active extra-package groups
 */
export const extraPackageListGroups = <ThrowOnError extends boolean = false>(options?: Options<ExtraPackageListGroupsData, ThrowOnError>) => (options?.client ?? client).get<ExtraPackageListGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/extra-package/group',
    ...options
});

/**
 * Get order by ID
 */
export const orderGetById = <ThrowOnError extends boolean = false>(options: Options<OrderGetByIdData, ThrowOnError>) => (options.client ?? client).get<OrderGetByIdResponses, OrderGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/order/{id}',
    ...options
});

export const paymentGetPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<PaymentGetPaymentMethodsData, ThrowOnError>) => (options?.client ?? client).get<PaymentGetPaymentMethodsResponses, PaymentGetPaymentMethodsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment/methods',
    ...options
});

/**
 * Save filtered image result as a completed generation task
 */
export const imageFilterApplyFilter = <ThrowOnError extends boolean = false>(options: Options<ImageFilterApplyFilterData, ThrowOnError>) => (options.client ?? client).post<ImageFilterApplyFilterResponses, ImageFilterApplyFilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/image-filter/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get newbie-pack campaign snapshot for current user
 */
export const uaNewbiePackGetSnapshot = <ThrowOnError extends boolean = false>(options?: Options<UaNewbiePackGetSnapshotData, ThrowOnError>) => (options?.client ?? client).get<UaNewbiePackGetSnapshotResponses, UaNewbiePackGetSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment-events/newbie-pack/snapshot',
    ...options
});

/**
 * Mark newbie-pack Aha popup as shown for current user account
 */
export const uaNewbiePackMarkAhaShown = <ThrowOnError extends boolean = false>(options?: Options<UaNewbiePackMarkAhaShownData, ThrowOnError>) => (options?.client ?? client).post<UaNewbiePackMarkAhaShownResponses, UaNewbiePackMarkAhaShownErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/payment-events/newbie-pack/aha-shown',
    ...options
});

/**
 * Get user decoration relation by ID
 */
export const userDecorationRelationGetUserDecorationRelation = <ThrowOnError extends boolean = false>(options: Options<UserDecorationRelationGetUserDecorationRelationData, ThrowOnError>) => (options.client ?? client).get<UserDecorationRelationGetUserDecorationRelationResponses, UserDecorationRelationGetUserDecorationRelationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user-decoration-relation/{id}',
    ...options
});

/**
 * Update user decoration relation
 */
export const userDecorationRelationUpdateUserDecorationRelation = <ThrowOnError extends boolean = false>(options: Options<UserDecorationRelationUpdateUserDecorationRelationData, ThrowOnError>) => (options.client ?? client).put<UserDecorationRelationUpdateUserDecorationRelationResponses, UserDecorationRelationUpdateUserDecorationRelationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user-decoration-relation/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the authenticated user's recently used billing emails
 *
 * Returns distinct billing emails the user has supplied at onerway checkout, most-recent first. Used to prefill the email field on the checkout form. The same email may have been entered multiple times; only the latest occurrence per email is returned.
 */
export const userOrderEmailList = <ThrowOnError extends boolean = false>(options?: Options<UserOrderEmailListData, ThrowOnError>) => (options?.client ?? client).get<UserOrderEmailListResponses, UserOrderEmailListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user-order-email',
    ...options
});

/**
 * List active home-banner items
 */
export const bannerList = <ThrowOnError extends boolean = false>(options?: Options<BannerListData, ThrowOnError>) => (options?.client ?? client).get<BannerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/banners',
    ...options
});

/**
 * List campaign ads for a language and category
 *
 * Returns the campaign banner / ad entries configured for the given category, falling back to English if the requested language is not present in the YAML config.
 */
export const campaignAdsList = <ThrowOnError extends boolean = false>(options?: Options<CampaignAdsListData, ThrowOnError>) => (options?.client ?? client).get<CampaignAdsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/campaign-ads',
    ...options
});

/**
 * List all claimable rewards
 *
 * Returns all available claim types with their current status for the authenticated user.
 */
export const claimList = <ThrowOnError extends boolean = false>(options?: Options<ClaimListData, ThrowOnError>) => (options?.client ?? client).get<ClaimListResponses, ClaimListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/claim',
    ...options
});

/**
 * Get claim info by id
 *
 * Returns the claim status for a specific claim type (e.g., pixai-daily-credits, agent-stamina-daily).
 */
export const claimGet = <ThrowOnError extends boolean = false>(options: Options<ClaimGetData, ThrowOnError>) => (options.client ?? client).get<ClaimGetResponses, ClaimGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/claim/{id}',
    ...options
});

/**
 * Claim a reward
 *
 * Claims the specified reward if available. Returns the updated claim status after claiming.
 */
export const claimClaim = <ThrowOnError extends boolean = false>(options: Options<ClaimClaimData, ThrowOnError>) => (options.client ?? client).post<ClaimClaimResponses, ClaimClaimErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/claim/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List contests with pagination and filters
 */
export const contestList = <ThrowOnError extends boolean = false>(options?: Options<ContestListData, ThrowOnError>) => (options?.client ?? client).get<ContestListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest',
    ...options
});

/**
 * List public contests
 */
export const contestV2List = <ThrowOnError extends boolean = false>(options?: Options<ContestV2ListData, ThrowOnError>) => (options?.client ?? client).get<ContestV2ListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/list',
    ...options
});

/**
 * List active contest banners
 */
export const contestV2ListBanner = <ThrowOnError extends boolean = false>(options?: Options<ContestV2ListBannerData, ThrowOnError>) => (options?.client ?? client).get<ContestV2ListBannerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/banner',
    ...options
});

/**
 * Check whether current user is eligible to create a contest
 *
 * Lightweight pre-flight for the contest create entry. Always 200. reasons collects every failed check, so the FE can render all missing requirements at once. Codes come from src/constants/errors.ts.
 */
export const contestV2CreateCheck = <ThrowOnError extends boolean = false>(options?: Options<ContestV2CreateCheckData, ThrowOnError>) => (options?.client ?? client).get<ContestV2CreateCheckResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/create/check',
    ...options
});

/**
 * Create a community contest
 */
export const contestV2Create = <ThrowOnError extends boolean = false>(options: Options<ContestV2CreateData, ThrowOnError>) => (options.client ?? client).post<ContestV2CreateResponses, ContestV2CreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List contests followed by a user
 *
 * Ordered by the listed user follow time desc. followAt belongs to the current viewer (null when anonymous or not following). When the viewer is the listed user or an admin, pending contests are included; other viewers see published contests only. Cancelled and draft contests are always hidden.
 */
export const contestV2ListFollowByUser = <ThrowOnError extends boolean = false>(options: Options<ContestV2ListFollowByUserData, ThrowOnError>) => (options.client ?? client).get<ContestV2ListFollowByUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/follow/{userId}',
    ...options
});

/**
 * List contests created by a user
 *
 * Ordered by creation time desc (id desc, since contest ids are snowflake-based). When the viewer is the listed user or an admin, every lifecycleStatus is returned; other viewers see published contests only. Visibility is enforced server-side; clients cannot filter by lifecycleStatus.
 */
export const contestV2ListCreatedByUser = <ThrowOnError extends boolean = false>(options: Options<ContestV2ListCreatedByUserData, ThrowOnError>) => (options.client ?? client).get<ContestV2ListCreatedByUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/created/{userId}',
    ...options
});

/**
 * Get contest detail by slug
 */
export const contestV2GetBySlug = <ThrowOnError extends boolean = false>(options: Options<ContestV2GetBySlugData, ThrowOnError>) => (options.client ?? client).get<ContestV2GetBySlugResponses, ContestV2GetBySlugErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}',
    ...options
});

/**
 * List artworks submitted to a contest
 */
export const contestV2ListArtwork = <ThrowOnError extends boolean = false>(options: Options<ContestV2ListArtworkData, ThrowOnError>) => (options.client ?? client).get<ContestV2ListArtworkResponses, ContestV2ListArtworkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/artwork',
    ...options
});

/**
 * Submit an artwork to a contest
 */
export const contestV2SubmitArtwork = <ThrowOnError extends boolean = false>(options: Options<ContestV2SubmitArtworkData, ThrowOnError>) => (options.client ?? client).post<ContestV2SubmitArtworkResponses, ContestV2SubmitArtworkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/artwork',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a user's submissions to a contest
 */
export const contestV2ListArtworkByUser = <ThrowOnError extends boolean = false>(options: Options<ContestV2ListArtworkByUserData, ThrowOnError>) => (options.client ?? client).get<ContestV2ListArtworkByUserResponses, ContestV2ListArtworkByUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/artwork/{userId}',
    ...options
});

/**
 * List awarded winners of a contest in rank order
 *
 * Returns [] while the contest is still pre-selection (rewardStatus null or pending_selection). Once winners are selected, returns artworks ordered by rank ascending; card.contest.entry carries rank / prizeAmount / source / submittedAt.
 */
export const contestV2ListWinners = <ThrowOnError extends boolean = false>(options: Options<ContestV2ListWinnersData, ThrowOnError>) => (options.client ?? client).get<ContestV2ListWinnersResponses, ContestV2ListWinnersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/winners',
    ...options
});

/**
 * Follow a contest
 */
export const contestV2Follow = <ThrowOnError extends boolean = false>(options: Options<ContestV2FollowData, ThrowOnError>) => (options.client ?? client).post<ContestV2FollowResponses, ContestV2FollowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/follow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unfollow a contest
 */
export const contestV2Unfollow = <ThrowOnError extends boolean = false>(options: Options<ContestV2UnfollowData, ThrowOnError>) => (options.client ?? client).post<ContestV2UnfollowResponses, ContestV2UnfollowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/contest/{slug}/unfollow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current user permissions for a model
 */
export const generationModelGetMyModelPermission = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetMyModelPermissionData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetMyModelPermissionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelId}/permission',
    ...options
});

/**
 * Get style keys for a model version
 */
export const generationModelGetStyleKeys = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetStyleKeysData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetStyleKeysResponses, GenerationModelGetStyleKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelVersionId}/style-keys',
    ...options
});

/**
 * Get features for a model
 */
export const generationModelGetFeaturesByModelVersionId = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetFeaturesByModelVersionIdData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetFeaturesByModelVersionIdResponses, GenerationModelGetFeaturesByModelVersionIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelVersionId}/features',
    ...options
});

/**
 * Get inference profiles for a model version
 */
export const generationModelGetInferenceProfiles = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetInferenceProfilesData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetInferenceProfilesResponses, GenerationModelGetInferenceProfilesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelVersionId}/inference-profiles',
    ...options
});

/**
 * Get size configuration for a model version
 */
export const generationModelGetSizeConfig = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetSizeConfigData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetSizeConfigResponses, GenerationModelGetSizeConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelVersionId}/size-config',
    ...options
});

/**
 * Get trending artworks for a generation model
 *
 * Returns trending public artworks generated with the given model, ranked by the `trending1` ES function-score (time-decay + log-scaled likes + quality signals + randomness — the same ranking the web app's "Trending" UI option resolves to via the GraphQL `feed: "trending1"` path). Distinct from `/most-liked`, which sorts by raw all-time like count.
 */
export const generationModelGetTrendingArtworksByModel = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetTrendingArtworksByModelData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetTrendingArtworksByModelResponses, GenerationModelGetTrendingArtworksByModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelId}/artworks/trending',
    ...options
});

/**
 * Get latest artworks for a generation model
 *
 * Returns the newest public artworks generated with the given model, ordered by `createdAt` descending. Same view-permission gate, type-default mirroring, and output shape as `/trending`; only the orderBy differs.
 */
export const generationModelGetLatestArtworksByModel = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetLatestArtworksByModelData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetLatestArtworksByModelResponses, GenerationModelGetLatestArtworksByModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelId}/artworks/latest',
    ...options
});

/**
 * Get most-liked artworks for a generation model
 *
 * Returns public artworks generated with the given model, ordered by raw all-time `likedCount` descending. Mirrors the GraphQL `artworks(loraId, orderBy: "-markInfo.likedCount")` query the web app uses for the "Most Liked" UI option. Distinct from `/trending`, which uses the `trending1` function-score ranking.
 */
export const generationModelGetMostLikedArtworksByModel = <ThrowOnError extends boolean = false>(options: Options<GenerationModelGetMostLikedArtworksByModelData, ThrowOnError>) => (options.client ?? client).get<GenerationModelGetMostLikedArtworksByModelResponses, GenerationModelGetMostLikedArtworksByModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/{modelId}/artworks/most-liked',
    ...options
});

/**
 * Import an external model by URL
 */
export const generationModelImportExternalModel = <ThrowOnError extends boolean = false>(options: Options<GenerationModelImportExternalModelData, ThrowOnError>) => (options.client ?? client).post<GenerationModelImportExternalModelResponses, GenerationModelImportExternalModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/generation-model/import-external',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check whether i18n usage tracking is enabled for the caller
 */
export const i18nGetTrackUsage = <ThrowOnError extends boolean = false>(options: Options<I18nGetTrackUsageData, ThrowOnError>) => (options.client ?? client).get<I18nGetTrackUsageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/i18n/track-usage',
    ...options
});

/**
 * Report i18n key usage from the frontend
 */
export const i18nPostTrackUsage = <ThrowOnError extends boolean = false>(options: Options<I18nPostTrackUsageData, ThrowOnError>) => (options.client ?? client).post<I18nPostTrackUsageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/i18n/track-usage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an image generation task
 */
export const imageCreate = <ThrowOnError extends boolean = false>(options: Options<ImageCreateData, ThrowOnError>) => (options.client ?? client).post<ImageCreateResponses, ImageCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/image/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a multimodal reference video task
 */
export const referenceVideoCreate = <ThrowOnError extends boolean = false>(options: Options<ReferenceVideoCreateData, ThrowOnError>) => (options.client ?? client).post<ReferenceVideoCreateResponses, ReferenceVideoCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/reference-video/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a style key ref
 *
 * Saves a style string and returns a short ref ID that can be used in generation parameters.
 */
export const styleKeyRefCreate = <ThrowOnError extends boolean = false>(options: Options<StyleKeyRefCreateData, ThrowOnError>) => (options.client ?? client).post<StyleKeyRefCreateResponses, StyleKeyRefCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/style-key-ref',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get campaign summary
 *
 * Returns campaign config, inviter eligibility, and invitation counts.
 */
export const referralCampaignSummary = <ThrowOnError extends boolean = false>(options?: Options<ReferralCampaignSummaryData, ThrowOnError>) => (options?.client ?? client).get<ReferralCampaignSummaryResponses, ReferralCampaignSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/referral-campaign/summary',
    ...options
});

/**
 * List invitation entries
 *
 * Returns paginated invitation records for the current user as inviter.
 */
export const referralCampaignEntries = <ThrowOnError extends boolean = false>(options?: Options<ReferralCampaignEntriesData, ThrowOnError>) => (options?.client ?? client).get<ReferralCampaignEntriesResponses, ReferralCampaignEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/referral-campaign/entries',
    ...options
});

/**
 * Get invitee status
 *
 * Returns the current user's qualification status as an invitee, or null.
 */
export const referralCampaignInviteeStatus = <ThrowOnError extends boolean = false>(options?: Options<ReferralCampaignInviteeStatusData, ThrowOnError>) => (options?.client ?? client).get<ReferralCampaignInviteeStatusResponses, ReferralCampaignInviteeStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/referral-campaign/invitee-status',
    ...options
});

/**
 * Clear SSR experiment cache for the current user
 *
 * Deletes the cached SSR experiment variant for the authenticated user, forcing a fresh lookup on next request.
 */
export const ssrClearExperimentCache = <ThrowOnError extends boolean = false>(options?: Options<SsrClearExperimentCacheData, ThrowOnError>) => (options?.client ?? client).get<SsrClearExperimentCacheResponses, SsrClearExperimentCacheErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/ssr/experiment-cache',
    ...options
});

/**
 * Get tier reward progress and status
 */
export const tierRewardGetRewardTiers = <ThrowOnError extends boolean = false>(options: Options<TierRewardGetRewardTiersData, ThrowOnError>) => (options.client ?? client).get<TierRewardGetRewardTiersResponses, TierRewardGetRewardTiersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/tier-rewards/{trackKey}',
    ...options
});

/**
 * Claim a single reward tier
 */
export const tierRewardClaim = <ThrowOnError extends boolean = false>(options: Options<TierRewardClaimData, ThrowOnError>) => (options.client ?? client).post<TierRewardClaimResponses, TierRewardClaimErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/tier-rewards/{trackKey}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim all available reward tiers
 */
export const tierRewardClaimAllAvailable = <ThrowOnError extends boolean = false>(options: Options<TierRewardClaimAllAvailableData, ThrowOnError>) => (options.client ?? client).post<TierRewardClaimAllAvailableResponses, TierRewardClaimAllAvailableErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/tier-rewards/{trackKey}/claim-all-available',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset tier reward progress and claims (admin only)
 */
export const tierRewardReset = <ThrowOnError extends boolean = false>(options: Options<TierRewardResetData, ThrowOnError>) => (options.client ?? client).post<TierRewardResetResponses, TierRewardResetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/event/{eventName}/tier-rewards/{trackKey}/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List kaisuuken cards by IDs for the current user
 */
export const kaisuukenList = <ThrowOnError extends boolean = false>(options: Options<KaisuukenListData, ThrowOnError>) => (options.client ?? client).post<KaisuukenListResponses, KaisuukenListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search kaisuuken cards for the current user with filters and pagination
 */
export const kaisuukenSearch = <ThrowOnError extends boolean = false>(options?: Options<KaisuukenSearchData, ThrowOnError>) => (options?.client ?? client).get<KaisuukenSearchResponses, KaisuukenSearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/search',
    ...options
});

/**
 * List summary of kaisuuken for the current user
 */
export const kaisuukenSummary = <ThrowOnError extends boolean = false>(options?: Options<KaisuukenSummaryData, ThrowOnError>) => (options?.client ?? client).get<KaisuukenSummaryResponses, KaisuukenSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/summary',
    ...options
});

/**
 * Check which kaisuuken match the given parameters. Returns up to 3 cards per template.
 */
export const kaisuukenCheck = <ThrowOnError extends boolean = false>(options: Options<KaisuukenCheckData, ThrowOnError>) => (options.client ?? client).post<KaisuukenCheckResponses, KaisuukenCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List kaisuuken templates by IDs
 */
export const kaisuukenTemplateList = <ThrowOnError extends boolean = false>(options: Options<KaisuukenTemplateListData, ThrowOnError>) => (options.client ?? client).post<KaisuukenTemplateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/template/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List consume logs for the current user with pagination
 */
export const kaisuukenLogs = <ThrowOnError extends boolean = false>(options?: Options<KaisuukenLogsData, ThrowOnError>) => (options?.client ?? client).get<KaisuukenLogsResponses, KaisuukenLogsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kaisuuken/logs',
    ...options
});

/**
 * Roll lottery for Spring Promotion 2026
 */
export const lotteryRoll = <ThrowOnError extends boolean = false>(options: Options<LotteryRollData, ThrowOnError>) => (options.client ?? client).post<LotteryRollResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/lottery/roll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Purchase lottery tokens
 */
export const lotteryPurchaseToken = <ThrowOnError extends boolean = false>(options: Options<LotteryPurchaseTokenData, ThrowOnError>) => (options.client ?? client).post<LotteryPurchaseTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/lottery/purchase-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim lottery progress reward
 */
export const lotteryClaimReward = <ThrowOnError extends boolean = false>(options: Options<LotteryClaimRewardData, ThrowOnError>) => (options.client ?? client).post<LotteryClaimRewardResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/lottery/claim-reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset lottery user state (debug/admin)
 */
export const lotteryReset = <ThrowOnError extends boolean = false>(options: Options<LotteryResetData, ThrowOnError>) => (options.client ?? client).post<LotteryResetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/lottery/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get validation-relevant media metadata
 */
export const mediaGetMediaInfo = <ThrowOnError extends boolean = false>(options: Options<MediaGetMediaInfoData, ThrowOnError>) => (options.client ?? client).get<MediaGetMediaInfoResponses, MediaGetMediaInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/media/{mediaId}/info',
    ...options
});

/**
 * Generate or get thumbnail media id for a video
 */
export const mediaGetVideoThumbnailId = <ThrowOnError extends boolean = false>(options: Options<MediaGetVideoThumbnailIdData, ThrowOnError>) => (options.client ?? client).post<MediaGetVideoThumbnailIdResponses, MediaGetVideoThumbnailIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/media/{videoMediaId}/thumbnail-id',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get S3 upload url for audio
 */
export const mediaGetAudioUploadUrl = <ThrowOnError extends boolean = false>(options: Options<MediaGetAudioUploadUrlData, ThrowOnError>) => (options.client ?? client).post<MediaGetAudioUploadUrlResponses, MediaGetAudioUploadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/media/audio/upload-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get file url for an audio media id
 */
export const mediaGetAudioUrl = <ThrowOnError extends boolean = false>(options: Options<MediaGetAudioUrlData, ThrowOnError>) => (options.client ?? client).post<MediaGetAudioUrlResponses, MediaGetAudioUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/media/audio/url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register uploaded audio by externalId
 */
export const mediaRegisterAudio = <ThrowOnError extends boolean = false>(options: Options<MediaRegisterAudioData, ThrowOnError>) => (options.client ?? client).post<MediaRegisterAudioResponses, MediaRegisterAudioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/media/audio/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OAuth2 authorization request
 *
 * Validate OAuth2 request parameters and return client info for the consent UI. Auth: requires authenticated user session (cookie).
 */
export const oauth2Authorize = <ThrowOnError extends boolean = false>(options: Options<Oauth2AuthorizeData, ThrowOnError>) => (options.client ?? client).get<Oauth2AuthorizeResponses, Oauth2AuthorizeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/authorize',
    ...options
});

/**
 * OAuth2 consent decision
 *
 * Record user consent and issue an authorization code if approved. Auth: requires authenticated user session (cookie).
 */
export const oauth2Consent = <ThrowOnError extends boolean = false>(options: Options<Oauth2ConsentData, ThrowOnError>) => (options.client ?? client).post<Oauth2ConsentResponses, Oauth2ConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OAuth2 token exchange
 *
 * Exchange an authorization code for tokens, or refresh an access token. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2Token = <ThrowOnError extends boolean = false>(options: Options<Oauth2TokenData, ThrowOnError>) => (options.client ?? client).post<Oauth2TokenResponses, Oauth2TokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a token
 *
 * Invalidate an access or refresh token. Always returns 200 per RFC 7009. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2Revoke = <ThrowOnError extends boolean = false>(options: Options<Oauth2RevokeData, ThrowOnError>) => (options.client ?? client).post<Oauth2RevokeResponses, Oauth2RevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Introspect a token
 *
 * Check whether a token is active and retrieve its metadata. Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2Introspect = <ThrowOnError extends boolean = false>(options: Options<Oauth2IntrospectData, ThrowOnError>) => (options.client ?? client).post<Oauth2IntrospectResponses, Oauth2IntrospectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/introspect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OAuth2 server metadata
 *
 * OAuth2 server configuration and endpoint discovery. Auth: none (public).
 */
export const oauth2ServerMetadata = <ThrowOnError extends boolean = false>(options: Options<Oauth2ServerMetadataData, ThrowOnError>) => (options.client ?? client).get<Oauth2ServerMetadataResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/.well-known/oauth-authorization-server',
    ...options
});

/**
 * OAuth2 device authorization request
 *
 * Request a device code and user code for the device authorization flow (RFC 8628). Auth: HTTP Basic (Authorization: Basic base64(client_id:client_secret)).
 */
export const oauth2DeviceAuthorization = <ThrowOnError extends boolean = false>(options: Options<Oauth2DeviceAuthorizationData, ThrowOnError>) => (options.client ?? client).post<Oauth2DeviceAuthorizationResponses, Oauth2DeviceAuthorizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/device_authorization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify a device user code
 *
 * Look up a device authorization request by user_code and return application info. Auth: requires authenticated user session (cookie).
 */
export const oauth2DeviceVerify = <ThrowOnError extends boolean = false>(options: Options<Oauth2DeviceVerifyData, ThrowOnError>) => (options.client ?? client).post<Oauth2DeviceVerifyResponses, Oauth2DeviceVerifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/device/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve or deny a device authorization
 *
 * Record user consent decision for a device code. Auth: requires authenticated user session (cookie).
 */
export const oauth2DeviceConsent = <ThrowOnError extends boolean = false>(options: Options<Oauth2DeviceConsentData, ThrowOnError>) => (options.client ?? client).post<Oauth2DeviceConsentResponses, Oauth2DeviceConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/oauth2/{applicationSlug}/device/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate OAuth flow with the named provider (302 to provider). Top-level navigation so the pre-auth cookie is set in a first-party context. `clientType` distinguishes web vs mobile in-app browser.
 */
export const oauth2ClientStart = <ThrowOnError extends boolean = false>(options: Options<Oauth2ClientStartData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/oauth/{provider}/start',
    ...options
});

/**
 * Provider callback. 302 to record.redirectUrl on success, 302 to ${appBaseUrl}/auth/error?code=… on failure.
 */
export const oauth2ClientCallback = <ThrowOnError extends boolean = false>(options: Options<Oauth2ClientCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/oauth/{provider}/callback',
    ...options
});

/**
 * Apple form-post callback variant (apple, apple2)
 */
export const oauth2ClientAppleCallback = <ThrowOnError extends boolean = false>(options: Options<Oauth2ClientAppleCallbackData, ThrowOnError>) => (options.client ?? client).post<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/oauth/{provider}/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange a native-SDK id_token for a session JWT
 */
export const oauth2ClientNative = <ThrowOnError extends boolean = false>(options: Options<Oauth2ClientNativeData, ThrowOnError>) => (options.client ?? client).post<Oauth2ClientNativeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/oauth/{provider}/native',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Redeem a single-use exchange code for a session JWT. Requires X-Device-Id matching the deviceId supplied at /start.
 */
export const oauth2ClientExchange = <ThrowOnError extends boolean = false>(options: Options<Oauth2ClientExchangeData, ThrowOnError>) => (options.client ?? client).post<Oauth2ClientExchangeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/auth/oauth/exchange',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exchange pixai credits for a kotone credit pack
 */
export const kotoneCreditExchangeCreditPack = <ThrowOnError extends boolean = false>(options: Options<KotoneCreditExchangeCreditPackData, ThrowOnError>) => (options.client ?? client).post<KotoneCreditExchangeCreditPackResponses, KotoneCreditExchangeCreditPackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kotone/credit/exchange-credit-pack',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim monthly membership kotone credit pack
 */
export const kotoneCreditClaimMonthlyMembershipCreditPack = <ThrowOnError extends boolean = false>(options?: Options<KotoneCreditClaimMonthlyMembershipCreditPackData, ThrowOnError>) => (options?.client ?? client).post<KotoneCreditClaimMonthlyMembershipCreditPackResponses, KotoneCreditClaimMonthlyMembershipCreditPackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kotone/credit/claim-monthly-membership-credit-pack',
    ...options
});

/**
 * Get monthly membership credit pack grant status
 */
export const kotoneCreditGetMonthlyMembershipGrantStatus = <ThrowOnError extends boolean = false>(options?: Options<KotoneCreditGetMonthlyMembershipGrantStatusData, ThrowOnError>) => (options?.client ?? client).get<KotoneCreditGetMonthlyMembershipGrantStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/kotone/credit/monthly-membership-grant-status',
    ...options
});

/**
 * Create a one-time purchase order for Kotone
 */
export const kotoneOrderCreate = <ThrowOnError extends boolean = false>(options: Options<KotoneOrderCreateData, ThrowOnError>) => (options.client ?? client).post<KotoneOrderCreateResponses, KotoneOrderCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/kotone/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Kotone order by ID
 */
export const kotoneOrderGet = <ThrowOnError extends boolean = false>(options: Options<KotoneOrderGetData, ThrowOnError>) => (options.client ?? client).get<KotoneOrderGetResponses, KotoneOrderGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/kotone/order/{orderId}',
    ...options
});

/**
 * Cancel a Kotone order
 */
export const kotoneOrderCancel = <ThrowOnError extends boolean = false>(options: Options<KotoneOrderCancelData, ThrowOnError>) => (options.client ?? client).post<KotoneOrderCancelResponses, KotoneOrderCancelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/kotone/order/{orderId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a Kotone order as completed (Agent confirms fulfillment)
 */
export const kotoneOrderComplete = <ThrowOnError extends boolean = false>(options: Options<KotoneOrderCompleteData, ThrowOnError>) => (options.client ?? client).post<KotoneOrderCompleteResponses, KotoneOrderCompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/kotone/order/{orderId}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a Kotone order as refunded (Agent confirms benefit revocation)
 */
export const kotoneOrderConfirmRefund = <ThrowOnError extends boolean = false>(options: Options<KotoneOrderConfirmRefundData, ThrowOnError>) => (options.client ?? client).post<KotoneOrderConfirmRefundResponses, KotoneOrderConfirmRefundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/kotone/order/{orderId}/confirm-refund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get content safety preferences for current user
 */
export const contentSafetyPreferenceGetContentSafetyPreferences = <ThrowOnError extends boolean = false>(options?: Options<ContentSafetyPreferenceGetContentSafetyPreferencesData, ThrowOnError>) => (options?.client ?? client).get<ContentSafetyPreferenceGetContentSafetyPreferencesResponses, ContentSafetyPreferenceGetContentSafetyPreferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/me/content-safety/preferences',
    ...options
});

/**
 * Update a content safety preference
 */
export const contentSafetyPreferenceUpdateContentSafetyPreference = <ThrowOnError extends boolean = false>(options: Options<ContentSafetyPreferenceUpdateContentSafetyPreferenceData, ThrowOnError>) => (options.client ?? client).put<ContentSafetyPreferenceUpdateContentSafetyPreferenceResponses, ContentSafetyPreferenceUpdateContentSafetyPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/me/content-safety/preferences/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a credit exchange transaction (partner-facing)
 */
export const creditExchangeCreateTransaction = <ThrowOnError extends boolean = false>(options: Options<CreditExchangeCreateTransactionData, ThrowOnError>) => (options.client ?? client).post<CreditExchangeCreateTransactionResponses, CreditExchangeCreateTransactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/credit-exchange/external/{partnerId}/transaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check redeem token status (partner-facing, S2S)
 */
export const creditExchangeExternalTokenStatus = <ThrowOnError extends boolean = false>(options: Options<CreditExchangeExternalTokenStatusData, ThrowOnError>) => (options.client ?? client).get<CreditExchangeExternalTokenStatusResponses, CreditExchangeExternalTokenStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/credit-exchange/external/{partnerId}/status',
    ...options
});

/**
 * Get redeem token summary (user-facing)
 */
export const creditExchangeTokenSummary = <ThrowOnError extends boolean = false>(options: Options<CreditExchangeTokenSummaryData, ThrowOnError>) => (options.client ?? client).get<CreditExchangeTokenSummaryResponses, CreditExchangeTokenSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/credit-exchange/token/{token}/summary',
    ...options
});

/**
 * Redeem a credit exchange token (user-facing)
 */
export const creditExchangeRedeemToken = <ThrowOnError extends boolean = false>(options: Options<CreditExchangeRedeemTokenData, ThrowOnError>) => (options.client ?? client).post<CreditExchangeRedeemTokenResponses, CreditExchangeRedeemTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/credit-exchange/token/{token}/redeem',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch get decorations by IDs
 *
 * Returns decorations matching the given IDs, ordered to match the input `ids`. Unknown IDs are silently omitted. Capped at 50 IDs per request.
 */
export const decorationBatch = <ThrowOnError extends boolean = false>(options: Options<DecorationBatchData, ThrowOnError>) => (options.client ?? client).get<DecorationBatchResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/decoration/batch',
    ...options
});

/**
 * Get decoration by ID
 */
export const decorationGetDecoration = <ThrowOnError extends boolean = false>(options: Options<DecorationGetDecorationData, ThrowOnError>) => (options.client ?? client).get<DecorationGetDecorationResponses, DecorationGetDecorationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/decoration/{id}',
    ...options
});

/**
 * Create an image generation task on behalf of a user
 */
export const internalImageCreate = <ThrowOnError extends boolean = false>(options: Options<InternalImageCreateData, ThrowOnError>) => (options.client ?? client).post<InternalImageCreateResponses, InternalImageCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/task/image/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bind two existing users as inviter/invitee in the referral system
 */
export const internalReferralBind = <ThrowOnError extends boolean = false>(options: Options<InternalReferralBindData, ThrowOnError>) => (options.client ?? client).post<InternalReferralBindResponses, InternalReferralBindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/referral/bind',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a task by ID (bypasses ownership check)
 *
 * Returns the current status and outputs of any task. Internal callers are trusted and skip user ownership verification. When `min_safety_score` is provided, `outputs` is blanked to an empty object ONLY when the task image has been moderated and its persisted safety score is below the threshold (known-unsafe). Tasks whose safety score is missing or still pending are returned as-is — callers that need a meaningful gate must opt their task into moderation at creation time (`moderationPolicy: "force"` on `/internal/task/image/create`).
 */
export const internalTaskGetById = <ThrowOnError extends boolean = false>(options: Options<InternalTaskGetByIdData, ThrowOnError>) => (options.client ?? client).get<InternalTaskGetByIdResponses, InternalTaskGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/task/{id}',
    ...options
});

/**
 * Get the moderation result of a task
 *
 * Returns safety scores for the task prompt and generated image. Returns `{ result: "not_ready" }` with HTTP 200 when the image moderation has not completed yet — the caller should keep polling. Returns 404 when the task does not exist.
 */
export const internalTaskGetModeration = <ThrowOnError extends boolean = false>(options: Options<InternalTaskGetModerationData, ThrowOnError>) => (options.client ?? client).get<InternalTaskGetModerationResponses, InternalTaskGetModerationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/task/{id}/moderation',
    ...options
});

/**
 * Create a chat-based image editing task on behalf of a user
 *
 * Creates a chat editing task for the specified user. Supports billing override, custom priority, and content moderation scene.
 */
export const internalTaskEditCreate = <ThrowOnError extends boolean = false>(options: Options<InternalTaskEditCreateData, ThrowOnError>) => (options.client ?? client).post<InternalTaskEditCreateResponses, InternalTaskEditCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/task/edit/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bind a PixAI user to an external account (idempotent + strict)
 *
 * Internal-only. Trusted by Rubert: assumes the external identity has already been verified upstream. Returns 201 when a new binding is created, 200 when an exact match already existed. Conflicts surface as structured 4xx errors. If `email` is provided, may also update the user's email/verified state per the design spec.
 */
export const internalUserExternalProfilesBind = <ThrowOnError extends boolean = false>(options: Options<InternalUserExternalProfilesBindData, ThrowOnError>) => (options.client ?? client).post<InternalUserExternalProfilesBindResponses, InternalUserExternalProfilesBindErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/user-external-profiles/bind',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a user's external profiles (optional provider filter)
 */
export const internalUserExternalProfilesListByUserId = <ThrowOnError extends boolean = false>(options: Options<InternalUserExternalProfilesListByUserIdData, ThrowOnError>) => (options.client ?? client).get<InternalUserExternalProfilesListByUserIdResponses, InternalUserExternalProfilesListByUserIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/internal/user-external-profiles/by-user',
    ...options
});

/**
 * List footprint preferences for a user
 *
 * Returns the top 50 most-recently-updated preference entries from the user's footprint namespace, sorted by `lastUpdatedAt` descending. The set of preference sub-types is bounded by design, so 50 is well beyond what any user can accumulate and no pagination is exposed. Pass `?keys=a,b` to restrict the response to a subset of sub-types. Accessible only to the user themselves or to admins. Responds 404 when the user's namespace has never been written to, and `[]` when the namespace exists but contains no preference entries.
 */
export const footprintListPreferences = <ThrowOnError extends boolean = false>(options: Options<FootprintListPreferencesData, ThrowOnError>) => (options.client ?? client).get<FootprintListPreferencesResponses, FootprintListPreferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/footprint/{userId}/preference',
    ...options
});

/**
 * List footprint actions for a user
 *
 * Returns the user's recorded action entries (likes, dislikes, publishes) sorted by `lastUpdatedAt` descending. Pass `?subTypes=a,b` to restrict to a subset, `?limit=N` (1–100, default 50) to control page size, and `?cursor=...` to fetch the next page using the `nextCursor` returned by the previous call. The `source` field (api_sync / cron_job / agent) is included only for admin requesters. Note: rows whose `lastUpdatedAt` is exactly equal at the cursor boundary may be skipped — millisecond collisions are rare in practice. Accessible only to the user themselves or to admins. Responds 404 when the namespace has never been written to, and an empty `entries` array when it exists but contains no matching action entries.
 */
export const footprintListActions = <ThrowOnError extends boolean = false>(options: Options<FootprintListActionsData, ThrowOnError>) => (options.client ?? client).get<FootprintListActionsResponses, FootprintListActionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/footprint/{userId}/action',
    ...options
});

/**
 * Get push notification preferences for the current user
 */
export const notificationPreferenceGetNotificationPreference = <ThrowOnError extends boolean = false>(options?: Options<NotificationPreferenceGetNotificationPreferenceData, ThrowOnError>) => (options?.client ?? client).get<NotificationPreferenceGetNotificationPreferenceResponses, NotificationPreferenceGetNotificationPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/notification/preferences',
    ...options
});

/**
 * Update push notification preferences for the current user
 */
export const notificationPreferenceSetNotificationPreference = <ThrowOnError extends boolean = false>(options: Options<NotificationPreferenceSetNotificationPreferenceData, ThrowOnError>) => (options.client ?? client).put<NotificationPreferenceSetNotificationPreferenceResponses, NotificationPreferenceSetNotificationPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/user/me/notification/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
